<ng-container *ngIf="dataSource">
  <h2 class="container font-bold text-2xl">{{ dataSource.Title }}</h2>

  <div class="bg-blue w-100 h-[27rem] lg:h-[24rem] relative mt-6">
    <div class="container flex flex-col lg:grid  xl:grid-cols-5 items-center gap-2 lg:gap-24">
      <!-- Sidebar -->
      <div class="bg-yellow-400 lg:shadow-lg relative lg:col-span-1 lg:flex lg:items-center lg:h-[27rem] lg:w-40 lg:right-0 lg:-top-6 lg:rounded-2xl rounded-lg py-2 lg:py-0 max-w-full mt-2
            lg:mt-0 x-scroll overflow-x-auto md:overflow-x-visible flex items-center">
        <ul class="flex flex-row lg:flex-col lg:justify-self-start px-4"
          *ngIf="dataSource?.Section?.Data?.FilterNavs as FilterNavs">
          <li *ngFor="let eachCity of FilterNavs; let i = index">
            <button [class.active-tab]="selectedTabName === eachCity.NameEn" (click)="handleTabChange(eachCity.NameEn)"
              [style]="selectedTabName === eachCity.NameEn ? { background: 'url('+eachCity.PictureUrl+')' } : null"
              class="lg:px-6 lg:py-3 lg:text-right lg:w-52 lg:text-base text-black text-base rounded-lg border-2 border-solid border-transparent cursor-pointer text-center w-auto px-4 py-2">
              <span> {{ eachCity.Name }} </span>
            </button>
          </li>
        </ul>
      </div>

      <!-- TabContent  -->
      <div class="flex items-center gap-4 lg:-mt-8  xl:col-span-4 max-w-full" id="affordable">
        <ng-container *ngIf="resetSwiper()">
          <iho-swiper [dataSource]="tabContent" [configs]="sliderConfigs" />
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #template let-data="data" let-i="index">
  <iho-hotels-card [ecolodgeType]="1" [dataSource]="data" />
</ng-template>
